<template>
  <v-tooltip left v-if="tooltip">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :icon="icon"
        :color="color"
        :class="classes"
        @click="showTeacherModal(id)"
        v-bind="attrs"
        v-on="on"
      >
        <slot></slot>
    </v-btn>
    </template>
    <span>{{ tooltipLabel }}</span>
  </v-tooltip>
  <v-btn v-else
      :icon="icon"
      :color="color"
      :class="classes"
      @click="showTeacherModal(id)"
    >
      <slot></slot>
    </v-btn>
</template>
<script>

  import { mapActions } from 'vuex';

  import { teachersService } from '../../utils/services/teachers.service';
  import TeacherModal from '../modals/Teachers/TeacherModal.vue';

export default {
    name: 'BtnAddEditTeacher',
    props: {
        id: {
            type: Number,
            default: 0,
        },
        icon: {
            type: Boolean,
            default: false,
        },
        tooltip: {
            type: Boolean,
            default: false,
        },
        tooltipLabel: {
            type: String,
            default: '',
        },
        color: {
            type: String,
            default: '',
        },
        classes: {
            type: String,
            default: '',
        },
        returnUrl: {
            type: String,
            default: '',
        },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),

      async showTeacherModal(id) {
        this.showModal({
          component: TeacherModal,
            data: {
              stored: {
                id,
                return_url: this.returnUrl,
              },
          },
          options: {
            title: this.$t('TEACHER'),
            onSave: (
              form,
              error,
            ) => teachersService.save(form)
            .then(() => {
              this.hideModal({});
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.$emit('actionend');
            }),
          },
        });
      },
    },
};
</script>
